var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{ref:"swiperList",staticClass:"scrollBox",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_vm._t("main")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }